import { ListSubheader, Typography, Stack } from '@vapor/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSquareArrowDownRight } from '@fortawesome/pro-light-svg-icons'
import { Key } from 'react'

type ListTenantProps = {
  name?: string | null
  isSelected?: boolean
}

export const ListTenant = (props: ListTenantProps) => {
  const { name, isSelected } = props
  return (
    <ListSubheader
      sx={{
        background: '#eee',
        paddingTop: '5px',
        paddingBottom: '5px',
      }}
    >
      <Stack direction="row" spacing={0.5} sx={{ display: 'flex', alignItems: 'center' }}>
        <FontAwesomeIcon icon={faSquareArrowDownRight} />
        <Typography variant="caption" sx={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', textTransform: 'uppercase', fontWeight: isSelected ? '600' : undefined }}>
          {name}
        </Typography>
      </Stack>
    </ListSubheader>
  )
}
